import { Button } from '../Button';
import { useToast } from '../../hooks';
import { apiService } from '../../services/api';
import SummarizeIcon from '@mui/icons-material/Summarize';
import saveAs from 'file-saver';
import { DataAutocomplete } from '../SelectResponsibles';
import { UserRole } from '../../services/api.types';
import { usersService } from '../../services/users.service';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';
import clsx from 'clsx';

dayjs().locale('pt-br');

interface GenerateExcelProps {
  user: DataAutocomplete | null;
  filterMonth: Dayjs;
  className?: string;
}

export const GenerateExcelButton = ({
  user,
  filterMonth,
  className,
}: GenerateExcelProps) => {
  const toast = useToast();

  const downloadExcel = async () => {
    if (!user) {
      toast.warning('Precisa selecionar um usuário antes');
      return;
    }

    try {
      const userData = await usersService.getUserDetailed(user.id);
      const selectedId =
        user.role === UserRole.TEACHER
          ? userData.id
          : userData.student.responsibleId;
      const selectedName =
        user.role === UserRole.TEACHER
          ? userData.displayName
          : userData.student.responsible.fullName;

      const startDate = filterMonth.startOf('month').toDate();
      const endDate = filterMonth.endOf('month').toDate();

      const excelBuffer = await apiService.getReportSummaryExcel(
        selectedId,
        startDate,
        endDate
      );
      const dataExcel = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const formattedSelectedName = selectedName
        .trim()
        .toLowerCase()
        .replace(' ', '_');
      const month = filterMonth.format('MMMM');

      saveAs(dataExcel, `${formattedSelectedName}_resumo_mes_${month}.xlsx`);
      toast.success('Sucesso ao gerar resumo dos relatórios!');
    } catch (error) {
      toast.error('Erro ao gerar relatório!');
    }
  };

  return (
    <Button
      startIcon={<SummarizeIcon />}
      circular
      onClick={downloadExcel}
      className={clsx('w-min whitespace-nowrap', className)}
    >
      Resumo em Excel
    </Button>
  );
};
